import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import CreateNewProfilesModals from '../create-new-profiles-modals/CreateNewProfilesModals';

import { openAddEntitiesModal } from 'modules/create-new-profiles/reducers/actions';

import { __t, applyTranslations } from 'utils/language';

import { CreateNewProfilesOpenedOn } from 'modules/create-new-profiles//types/CreateNewProfiles.type';

import './create-new-profiles-button.scss';

applyTranslations(require('./create-new-profiles-button.i18n.json'));

interface OwnProps {
  openedOn: CreateNewProfilesOpenedOn
}

interface Props {
  dispatchOpenModal: () => void
}

const CreateNewProfilesButton = ({ dispatchOpenModal }: Props): JSX.Element => (
  <React.Fragment>
    <ActionButton
      color="secondary"
      className="create-new-profiles-button"
      onClick={dispatchOpenModal}
    >
      {__t('create_new_profiles_bunnot.label')}
    </ActionButton>
    <CreateNewProfilesModals />
  </React.Fragment>
);

const mapDispatchToProps = (dispatch, ownProps: OwnProps): Props => ({
  dispatchOpenModal: () => dispatch(openAddEntitiesModal(ownProps.openedOn))
});

export default connect(null, mapDispatchToProps)(CreateNewProfilesButton);
